import { createAction } from 'redux-actions';

export const createJobStatus = createAction('CREATE_JOB_STATUS');
export const createJobStatusSuccess = createAction('CREATE_JOB_STATUS_SUCCESS');
export const createJobStatusFailure = createAction('CREATE_JOB_STATUS_FAILURE');

export const deleteJobStatus = createAction('DELETE_JOB_STATUS');
export const deleteJobStatusSuccess = createAction('DELETE_JOB_STATUS_SUCCESS');
export const deleteJobStatusFailure = createAction('DELETE_JOB_STATUS_FAILURE');